export const Divider = () => {
  return (
    <div className='px-[12px] py-[8px]'>
      <div className='border-t border-gray-300' />
    </div>
  );
};
